import { createRouter, createWebHistory } from "vue-router";
// import Tables from "../views/Tables.vue";
// import VirtualReality from "../views/VirtualReality.vue";
// import RTL from "../views/Rtl.vue";
// import Profile from "../views/Profile.vue";
import authRoutes from '@/modules/auth/router/index';
import adminRoutes from '@/modules/admin/router/index';
import gestionRoutes from '@/modules/gestion/router/index';
import { authGuard } from "@/router/guards/authGuard";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      meta:{
        requiresGuest: true,
      },
      component: () => import('@/layouts/auth/AuthLayout.vue'),
      children: authRoutes,
    },
    {
      path: "/admin",
      meta:{
        requiresAuth: true,
      },
      component: () => import('@/layouts/gestion/GestionLayout.vue'),
      children: adminRoutes,
    },
    {
      path: "/gestion",
      meta:{
        requiresAuth: true,
      },
      component: () => import('@/layouts/gestion/GestionLayout.vue'),
      children: gestionRoutes,
    },
    // {
    //   path: "/tables",
    //   name: "Tables",
    //   component: Tables,
    //   meta: { requiresAuth: true }
    // },
    // {
    //   path: "/virtual-reality",
    //   name: "Virtual Reality",
    //   component: VirtualReality,
    //   meta: { requiresAuth: true }
    // },
    // {
    //   path: "/rtl-page",
    //   name: "RTL",
    //   component: RTL,
    //   meta: { requiresAuth: true }
    // },
    // {
    //   path: "/profile",
    //   name: "Profile",
    //   component: Profile,
    //   meta: { requiresAuth: true }
    // },
    {
      path: "/dashboard-default",
      name: "DashboardDefault",
      component: () => import('@/layouts/gestion/GestionLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          component: () => import('@/modules/admin/views/Dashboard.vue')
        }
      ]
    }
  ],
  linkActiveClass: "active",
});



router.beforeEach(authGuard);

export default router;
